import { siteConfig, type LanguageConfig } from '@/lib/config/site-config';
import {
    buildLanguagePath,
    getDefaultLanguage as getConfigDefaultLanguage,
    getEnabledLanguages as getConfigEnabledLanguages,
    getLanguageFromPath,
} from '@/lib/config/utils';

const normalizePath = (path?: string | null): string => {
    if (!path) {
        return '/';
    }
    return path.startsWith('/') ? path : `/${path}`;
};

export const languages: LanguageConfig[] = getConfigEnabledLanguages();

export const getEnabledLanguages = (): LanguageConfig[] => getConfigEnabledLanguages();

export const getDefaultLanguage = (): LanguageConfig => getConfigDefaultLanguage();

export const getLanguageByCode = (code: string): LanguageConfig | null =>
    siteConfig.languages.find(lang => lang.enabled && lang.code === code) ?? null;

export const getCurrentLanguage = (pathname: string): LanguageConfig => {
    return getLanguageFromPath(normalizePath(pathname));
};

export const getLanguagePath = (langCode: string, currentPath: string): string => {
    return buildLanguagePath(langCode, normalizePath(currentPath));
};
